<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Order Log</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.log_id"
              >
                <template v-if="r.is_staff">
                  <!-- <td class="text-right pr-2">
                    <display-branch-in-log :data="r" />
                  </td> -->
                  <td style="padding-left: 20%;">
                    your staff
                    <router-link :to="'/users?name=' + r.full_name"><a tooltip="View Staff">{{ r.full_name }}</a></router-link>&nbsp;
                    <span v-if="r.status === 'new_order'">
                      <span class="label bg-primary-600"> requested</span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'branch_delivery'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-violet-600"> branch </span>
                    </span>
                    <span v-else-if="r.status === 'delivered' || r.status === 'archived'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-warning-300"> customer</span>
                    </span>
                    <span v-else-if="r.status === 'warehouse_delivered_order'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-purple-400"> warehouse</span></span>
                    <span v-else-if="r.status === 'int_shipment'">
                      <span class="label bg-info-400"> shipmented </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'processed_order'">
                      <span class="label bg-indigo-600"> processed </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'canceled'">
                      <span class="label bg-orange-600"> canceled</span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'approved_order'">
                      <span class="label bg-green-600"> approved </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'refunded'">
                      <span class="label bg-danger-600"> refunded </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else>
                      <span class="label bg-teal-400"> purchased </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    &nbsp; at <span v-if="r.log_date != null">{{ r.log_date }}</span>
                    <span v-else>{{ r.created_at }}</span>
                  </td>
                </template>

                <template v-else>
                  <!-- <td class="text-right pr-2">
                    <display-branch-in-log :data="r" />
                  </td> -->
                  <td style="padding-left: 20%;">
                    #{{ r.log_id }} &nbsp; your customer
                    <router-link :to="'/regular-user?name=' + r.full_name"><a tooltip="View customer">{{ r.full_name }}</a></router-link>&nbsp;
                    <span v-if="r.status === 'new_order'">
                      <span class="label bg-primary-600"> requested</span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'branch_delivery'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-violet-600"> branch </span>
                    </span>
                    <span v-else-if="r.status === 'delivered'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-warning-300"> customer</span>
                    </span>
                    <span v-else-if="r.status === 'warehouse_delivered_order'">
                      delivered the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                      to <span class="label bg-purple-400"> warehouse</span></span>
                    <span v-else-if="r.status === 'int_shipment'">
                      <span class="label bg-info-400"> shipmented </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'processed_order'">
                      <span class="label bg-indigo-600"> processed </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'canceled'">
                      <span class="label bg-orange-600"> canceled</span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'approved_order'">
                      <span class="label bg-green-600"> approved </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else-if="r.status === 'refunded'">
                      <span class="label bg-danger-600"> refunded </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    <span v-else>
                      <span class="label bg-teal-400"> purchased </span> the order
                      <a
                        tooltip="View Order"
                        @click="initDetail('modal_showApp', r.order_id)"
                      >
                        #{{ r.theOrderID }}</a>
                    </span>
                    &nbsp; at <span v-if="r.log_date != null">{{ r.log_date }}</span>
                    <span v-else>{{ r.created_at }}</span>
                  </td>
                </template>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import axios from 'axios'
import swal from 'sweetalert'
// import DisplayBranchInLog from '../DisplayBranchInLog.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails
    // DisplayBranchInLog
  },
  mounted() {
    this.perPageFix()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = []
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/logs',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      logID: [],
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'log_id',
      sortOrders: sortOrders,
      detialData: {
        the_tl_price: '',
        cancel_reason: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        bank_name: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        coupon_percentage: '',
        delivery_type: '',
        theOrderID: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'log_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'log_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'log_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          // if (data.data.length > 0) {
          //   this.filterMade = true
          //   this.apiResults = data.data
          // } else {
          this.filterMade = false
          this.apiResults = data.data.data
          // }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          // if (data.data.length > 0) {
          //   this.removeConfigPagination()
          // } else {
          this.configPagination(data.data)
          // }
          this.getLogID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    getLogID(logs) {
      this.logID = []
      for (let i = 0; i < logs.length; i++) {
        this.logID[i] = logs[i].log_id
      }
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.logID.length; i++) {
        if (i < this.logID.length - 1) {
          arr = arr.concat('arr[]=' + this.logID[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.logID[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/order-log-export?' + arr)
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'log_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'log_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderLog.vue